import { cn } from "@/lib/utils";
import { cva, type VariantProps } from "class-variance-authority";

const skeletonVariants = cva(
  "rounded-md bg-muted relative overflow-hidden",
  {
    variants: {
      animation: {
        pulse: "animate-pulse",
        shimmer: "skeleton-shimmer",
        wave: "skeleton-wave",
        glow: "skeleton-glow",
      },
    },
    defaultVariants: {
      animation: "shimmer",
    },
  }
);

interface SkeletonProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof skeletonVariants> {}

function Skeleton({ className, animation, ...props }: SkeletonProps) {
  return (
    <div 
      className={cn(skeletonVariants({ animation }), className)} 
      {...props} 
    />
  );
}

export { Skeleton, skeletonVariants };
